import { render } from "./PackageMenuDropdown.vue?vue&type=template&id=94211030"
import script from "./PackageMenuDropdown.vue?vue&type=script&lang=js"
export * from "./PackageMenuDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script